import React, { useMemo, useEffect, useRef } from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { NavItem } from 'tbk-components/src/components/Nav';
import FooterNavItem from './FooterNavItem';

export interface IFooterMenuProps extends IBaseElementProps {
	footerColumnLogo?: IImage;
	footerColumnLogoURL?: ILink;
	footerColumnCTA?: ILink;
	footerColumnCTAColor?:
		| 'Light'
		| 'Dark'
		| 'Primary'
		| 'ITCS Primary'
		| 'ITCS Accent';
	addressTitle?: string;
	address?: string;
	addressUrl?: ILink;
	footerMenu?: NavItem[];
}

const FooterMenu: React.FC<IFooterMenuProps> = ({
	className,
	classNames = [],
	footerColumnLogo,
	footerColumnLogoURL,
	footerColumnCTA,
	footerColumnCTAColor,
	addressTitle,
	address,
	addressUrl,
	footerMenu,
}) => {
	const columns = useMemo(() => {
		let columns = [];
		let currentColumn = {
			type: 'simple',
			navItems: [],
		};

		footerMenu.forEach((item) => {
			if (item.label === '' || item.label === 'empty-label') {
				item.label = 'Empty Label';
				item.classNames.push('empty-label');
			}
			if (item.classNames && item.classNames.includes('column-break')) {
				columns.push(currentColumn);
				currentColumn = {
					type: 'simple',
					navItems: [],
				};
			}
			currentColumn.navItems.push(item);
		});
		columns.push(currentColumn);

		columns.forEach((column) => {
			column.navItems.forEach((item) => {
				if (item.children) {
					if (item.children[0].children) {
						column.type = 'contains-tabs';
					} else {
						column.type = 'contains-dropdown';
					}
				}
			});
		});
		return columns;
	}, [footerMenu]);

	return (
		<div
			className={
				className ||
				cn('calian-footer__middle container-fluid', ...classNames)
			}
		>
			<div className="calian-footer__middle--content container">
				<div className="calian-footer__middle--columns row">
					{footerColumnLogo && (
						<div className="col-auto calian-footer__column contains-callout">
							{footerColumnLogo && footerColumnLogoURL && (
								<a
									className="calian-footer__column--navbar-brand navbar-brand"
									href={footerColumnLogoURL.href}
									target={footerColumnLogoURL.target}
								>
									<Image
										{...footerColumnLogo}
										className="img-fluid"
									/>
								</a>
							)}
							{footerColumnCTA && (
								<Button
									className={cn(
										'calian-footer__cta-btn btn btn-sm',
										{
											[`btn-${kebabCase(
												footerColumnCTAColor,
											)}`]: footerColumnCTAColor,
										},
									)}
									{...footerColumnCTA}
								/>
							)}
						</div>
					)}
					{columns.map((column, index) => {
						let columnClassNames = column.classNames
							? column.classNames
							: [];
						return (
							<div
								key={index}
								className={cn(
									'col-auto calian-footer__column',
									`${column.type}`,
									...columnClassNames,
								)}
							>
								{/* If it is the first column, show the address */}
								{index === 0 && (
									<>
										{addressTitle && (
											<h5 className="calian-footer__address-title pe-md-4">
												{addressTitle}
											</h5>
										)}
										{/* If address URL is not empty show address link if it is just show address */}
										{address != undefined && (
											<>
												{addressUrl &&
												addressUrl.href ? (
													<p className="calian-footer__address pb-2 pb-lg-0">
														<a
															className="text-decoration-none link-charcoal text-primary-hover"
															href={
																addressUrl.href
															}
															target={
																addressUrl.target
															}
														>
															{address}
														</a>
													</p>
												) : (
													<p className="calian-footer__address w-lg-50 pb-2 pb-lg-0">
														{address}
													</p>
												)}
											</>
										)}
									</>
								)}

								{column.navItems.map((item, index) => {
									return (
										<FooterNavItem
											item={item}
											key={index}
										/>
									);
								})}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default FooterMenu;
